import { QueryLoader } from "@jsq/ds/core";
import { MinimalQueryResult } from "@jsq/ds/types";
import { queryLoader, gridWrapper } from "./style_vanilla.css";

export const PageWrapper = ({
  children,
  result,
  testId,
}: {
  children: React.ReactNode;
  result: MinimalQueryResult | MinimalQueryResult[];
  testId?: string;
}) => {
  return (
    <div className={queryLoader} {...(testId && { "data-testid": testId })}>
      <QueryLoader result={result}>
        <div data-testid="page-wrapper" className={gridWrapper}>
          {children}
        </div>
      </QueryLoader>
    </div>
  );
};
